import React from 'react';
import {connect} from 'react-redux';
import {LoadingPage} from 'components/loading-page';
import {CategoryMenu} from 'components/category';
import {withRouter} from 'react-router-dom';
import {ListProductResult} from 'components/list-product/list-product-result';
import {Products} from 'api';
import {parse} from 'qs';
import {NoContent} from 'components/no-content';
import isEmpty from 'lodash/isEmpty';
import {ShowIf, stripTags} from 'components/utils';

class SearchProduct extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      count: 0,
      skip: 0,
      limit: 12,
      isLoading: false,
      query: parse(this.props.location.search.substr(1)),
      search: ''
    };
    this.loadMore = this.loadMore.bind(this);
  }

  componentDidMount() {
    if (!isEmpty(this.state.query)) {
      this.getList(this.state.query.q);
    }
  }

  componentWillReceiveProps(nextProps) {
    let query = parse(nextProps.location.search.substr(1));

    if (query.q != this.state.query.q) {
      this.setState({
        query
      });

      this.getList(query.q);
    }
  }

  getList(q, initial = []) {
    if (!isEmpty(this.state.query)) {
      this.setState({isLoading: true});
      let params = {
        q: stripTags(q),
        limit: this.state.limit,
        offset: this.state.skip
      };

      Products.actions.search.request(params).then(response => {
        if (response && response.data) {
          let products = initial;

          response.data.results.map((item, idx) => {
            products.push(item);
          });
          this.setState({
            data: products,
            isLoading: false,
            count: response.data.total
          });
        }
      }).catch(() => {
        this.setState({isLoading: false});
      });
    }
  }

  loadMore() {
    this.setState({skip: this.state.skip + this.state.limit}, () => {
      this.getList(this.state.query.q, this.state.data);
    });
  }

  render() {
    const {isLoading, skip, limit, count, query} = this.state;
    return (
      <section className="search-product center">
        <LoadingPage isShow={isLoading} />
        <div className="search-product-container">
          <CategoryMenu/>
          <div className="search-results">
            <ShowIf condition={this.state.data.length > 0}>
              <h2 className="search-results-title">Tìm thấy: <strong>{count}</strong> kết quả với từ khoá &apos;<strong>{query.q}</strong>&apos;</h2>
            </ShowIf>
            <div className="product-right-list">
              <div className="product-right-wrap">
                <ShowIf condition={this.state.data.length > 0}>
                  <ListProductResult data={this.state.data} />
                </ShowIf>
                <ShowIf condition={this.state.data.length == 0 && !this.state.isLoading}>
                  <NoContent content='Không có kết quả nào' height={600}/>
                </ShowIf>
                <ShowIf condition={!isLoading && this.state.data.length > 0 && (skip + limit) < count}>
                  <button type="button" className="btn-viewmore-product" onClick={this.loadMore}>
                    <span className="btn-viewmore-text">Xem Thêm</span>
                  </button>
                </ShowIf>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}


export default withRouter(connect()(SearchProduct));



// WEBPACK FOOTER //
// ./components/search-product/SearchProduct.jsx